module.exports = __webpack_public_path__ + "static/img/esdgsj.e8372d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/esdgsj.png
// module id = dyr6
// module chunks = 31